import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@systemeio/ui';
import { useEffect, useRef } from 'react';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { twMerge } from 'tailwind-merge';
import { useNotifications } from '../hooks/use-notifications';
import UnreadIndicator from './unread-indicator';
import { useOpenNotificationMenuQuery } from '../hooks/use-open-notification-menu-query';
import { BellIcon } from '@systemeio/ui/icons';
import { useActualHeaderLayoutType } from 'shared/components/header';
import { NotificationsMenuContent } from './notifications-menu-content';
export interface NotificationMenuProps {
  className?: string;
}
const defaultFilter = {
  onlyUnRead: false
};
export const NotificationMenu = t0 => {
  const $ = _c(18);
  const {
    className
  } = t0;
  const menuRef = useRef(null);
  const {
    pagination
  } = usePagination(true);
  let t1;
  if ($[0] !== pagination) {
    t1 = {
      shouldFetchNotifications: false,
      limit: 3,
      pagination,
      filter: defaultFilter
    };
    $[0] = pagination;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    notificationsMeta
  } = useNotifications(t1);
  const {
    isDesktop
  } = useActualHeaderLayoutType();
  const t2 = isDesktop === true;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      allowCheck: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    openThroughQuery,
    setOpenThroughQuery
  } = useOpenNotificationMenuQuery(t3);
  let t4;
  let t5;
  if ($[4] !== openThroughQuery) {
    t4 = () => {
      if (openThroughQuery) {
        menuRef.current?.click();
      }
    };
    t5 = [openThroughQuery];
    $[4] = openThroughQuery;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  const t6 = openThroughQuery ? "click" : undefined;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      gap: 13,
      to: "top end",
      offset: 135
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <NotificationsMenuContent className="w-[500px] rounded-lg" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== setOpenThroughQuery) {
    t9 = () => setOpenThroughQuery(false);
    $[9] = setOpenThroughQuery;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== notificationsMeta?.hasUnread) {
    t10 = show => <div className="focus-visible:border-brand-primary flex h-full items-center justify-around gap-2.5 border-b-4 border-transparent focus:outline-hidden"><div className="text-background-secondary/90 relative w-5 text-sm font-bold"><BellIcon className={twMerge("fill-background-tertiary stroke-background-tertiary hover:fill-background-secondary hover:stroke-background-secondary w-4 transition", show && "fill-background-secondary stroke-background-secondary")} />{notificationsMeta?.hasUnread && <UnreadIndicator className="absolute right-0 top-0 p-0 " iconClassName="w-2 h-2" />}</div></div>;
    $[11] = notificationsMeta?.hasUnread;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== className || $[14] !== t10 || $[15] !== t6 || $[16] !== t9) {
    t11 = <><Tooltip popoverButtonRef={menuRef} mode={t6} anchor={t7} className={className} stayOnHover={true} popoverClassName="p-0 shadow-lg rounded-lg" wrapperClassName="h-full" label={t8} afterLeave={t9}>{t10}</Tooltip></>;
    $[13] = className;
    $[14] = t10;
    $[15] = t6;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};